import { render, staticRenderFns } from "./RecipePhotoForm.vue?vue&type=template&id=2acefff2&scoped=true"
import script from "./RecipePhotoForm.vue?vue&type=script&lang=js"
export * from "./RecipePhotoForm.vue?vue&type=script&lang=js"
import style0 from "./RecipePhotoForm.vue?vue&type=style&index=0&id=2acefff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acefff2",
  null
  
)

export default component.exports